/**
 * Converts feet and inches to inches.
 * @param feet The number of feet.
 * @param inches The number of inches.
 * @returns The total number of inches.
 */
export function convertFeetAndInchesToInches(feet: number, inches: number): number {
  return parseFloat((feet * 12 + inches).toFixed(2));
}

/**
 * Converts inches to feet and inches.
 * @param inches The number of inches.
 * @returns An object containing the number of feet and inches.
 */
export function convertInchesToFeetAndInches(inches: number): { feet: number; inches: number } {
  const feet = Math.floor(inches / 12);
  const remainingInches = parseFloat((inches % 12).toFixed(2));
  return { feet, inches: remainingInches };
}

/**
 * Converts weeks to weeks and days.
 * @param weeks The number of weeks.
 * @returns An object with the properties 'weeks' and 'days'.
 */
export function convertWeeksToWeeksAndDays(weeks: number): { weeks: number; days: number } {
  const wholeWeeks = Math.floor(weeks);
  const remainingDays = Math.floor((weeks - wholeWeeks) * 7);
  return { weeks: wholeWeeks, days: remainingDays };
}
